export const MasterThemeJson = {
  palette: {
    neutral: {
      contrastText: "#ffffff",
      main: "#64748B",
      light: "#838fa2",
      dark: "#465161",
    },
    chartColor1: {
      contrastText: "#000000",
      main: "#f5f5f5",
      light: "#f7f7f7",
      dark: "#ababab",
    },
    chartColor2: {
      contrastText: "#000000",
      main: "#eeeeee",
      light: "#f1f1f1",
      dark: "#a6a6a6",
    },
    chartColor3: {
      contrastText: "#000000",
      main: "#e0e0e0",
      light: "#e6e6e6",
      dark: "#9c9c9c",
    },
    chartColor4: {
      contrastText: "#000000",
      main: "#bdbdbd",
      light: "#cacaca",
      dark: "#848484",
    },
    chartColor5: {
      contrastText: "#000000",
      main: "#9e9e9e",
      light: "#b1b1b1",
      dark: "#6e6e6e",
    },

    chartColor6: {
      contrastText: "#ffffff",
      main: "#757575",
      light: "#909090",
      dark: "#515151",
    },

    chartColor7: {
      contrastText: "#ffffff",
      main: "#616161",
      light: "#808080",
      dark: "#434343",
    },

    chartColor8: {
      contrastText: "#ffffff",
      main: "#424242",
      light: "#676767",
      dark: "#2e2e2e",
    },

    chartColor9: {
      contrastText: "#ffffff",
      main: "#212121",
      light: "#4d4d4d",
      dark: "#171717",
    },
  },
};

export const MasterPallete = {
  gray: {
    contrastText: "#FFFFFF",
    main: "#5F5F5F",
    light: "#767676",
    dark: "#4F4F4F",
  },
  bronze: {
    contrastText: "#F1E5B9",
    main: "#8A4E16",
    light: "#8A4E16",
    dark: "#8A4E16",
    border: "#ffffff",
  },
  silver: {
    contrastText: "#5F736F",
    main: "#D7DFDE",
    light: "#D7DFDE",
    dark: "#D7DFDE",
    border: "#ffffff",
  },
  gold: {
    contrastText: "#FFF6DE",
    main: "#CE9911",
    light: "#CE9911",
    dark: "#CE9911",
    border: "#ffffff",
  },
  platinum: {
    contrastText: "#43828D",
    main: "#DEF4F8",
    light: "#DEF4F8",
    dark: "#DEF4F8",
    border: "#ffffff",
  },
  neutral: {
    contrastText: "#ffffff",
    main: "#64748B",
    light: "#838fa2",
    dark: "#465161",
  },
  chartColor1: {
    contrastText: "#000000",
    main: "#f5f5f5",
    light: "#f7f7f7",
    dark: "#ababab",
  },
  chartColor2: {
    contrastText: "#000000",
    main: "#eeeeee",
    light: "#f1f1f1",
    dark: "#a6a6a6",
  },
  chartColor3: {
    contrastText: "#000000",
    main: "#e0e0e0",
    light: "#e6e6e6",
    dark: "#9c9c9c",
  },
  chartColor4: {
    contrastText: "#000000",
    main: "#bdbdbd",
    light: "#cacaca",
    dark: "#848484",
  },
  chartColor5: {
    contrastText: "#000000",
    main: "#9e9e9e",
    light: "#b1b1b1",
    dark: "#6e6e6e",
  },

  chartColor6: {
    contrastText: "#ffffff",
    main: "#757575",
    light: "#909090",
    dark: "#515151",
  },

  chartColor7: {
    contrastText: "#ffffff",
    main: "#616161",
    light: "#808080",
    dark: "#434343",
  },

  chartColor8: {
    contrastText: "#ffffff",
    main: "#424242",
    light: "#676767",
    dark: "#2e2e2e",
  },

  chartColor9: {
    contrastText: "#ffffff",
    main: "#212121",
    light: "#4d4d4d",
    dark: "#171717",
  },
};
